export default "__VITE_ASSET__C0Xs21G1__"